import React from 'react';
import { RouteProps } from 'react-router';
import { ProtectedRoute } from 'components/common/ProtectedRoute';
import { useSite } from 'context/SiteContext';
import {
  STAFF_APPT_OPTIONS_URL,
  STAFF_OTHER_REFERRERS_MERGE_URL,
  STAFF_OTHER_REFERRERS_URL,
} from 'routes/AppRoutes';
import { Redirect } from 'react-router-dom';
import { isGpSurgeryRequired } from 'utils/siteUtils';

export const StaffListsRoute: React.FunctionComponent<RouteProps> = ({
  path,
  ...rest
}) => {
  const { activeSite } = useSite();
  if (
    !isGpSurgeryRequired(activeSite) &&
    path !== STAFF_OTHER_REFERRERS_URL &&
    path !== STAFF_OTHER_REFERRERS_MERGE_URL &&
    path !== STAFF_APPT_OPTIONS_URL
  ) {
    return <Redirect to={STAFF_OTHER_REFERRERS_URL} />;
  }
  return <ProtectedRoute {...rest} path={path} />;
};
